import { useState } from "react";
import { IntegrationContext } from "../contexts/IntegrationContext";

// provider sub microfront-end apps with the ability to load components from each other
// for example project app needs to load a component from sms app
// note: this component cannot be moved to shared app as the import names are not defined there
export default function IntegrationProvider(props: {
    children: JSX.Element | JSX.Element[];
}) {
    const [badgeNeedsRefresh, setBadgeNeedsRefresh] = useState(true);

    const value = {
        badgeNeedsRefresh: badgeNeedsRefresh,
        refreshBadgeCount: () => {
            setBadgeNeedsRefresh(true);
        },
        onBadgeFetched() {
            setBadgeNeedsRefresh(false);
        },
    };

    return (
        <IntegrationContext.Provider value={value}>
            {props.children}
        </IntegrationContext.Provider>
    );
}
